import { useTranslation } from "react-i18next";
import type { StorageUploadProgress } from "@/lib/storageUpload";
import { cn } from "@/lib/utils";

interface StorageUploadProgressBarProps {
  upload: StorageUploadProgress;
  size?: "sm" | "md";
  trackClassName: string;
  fillClassName: string;
  labelClassName: string;
}

export function StorageUploadProgressBar({
  upload,
  size = "md",
  trackClassName,
  fillClassName,
  labelClassName,
}: StorageUploadProgressBarProps) {
  const { t } = useTranslation("components");
  const label =
    upload.phase === "processing"
      ? t("storageUploadProcessing")
      : t("storageUploadPercent", { percent: upload.progress });

  return (
    <>
      <div
        className={cn(
          "overflow-hidden rounded-full",
          size === "sm" ? "h-1.5" : "h-2",
          trackClassName,
        )}
      >
        <div
          className={cn("h-full rounded-full transition-[width] duration-150", fillClassName)}
          style={{ width: `${upload.progress}%` }}
        />
      </div>
      <p className={cn("mt-1 text-center font-medium", labelClassName)}>
        {label}
      </p>
    </>
  );
}
